export default {
  tablename: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  DateStart: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  DateEnd: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/log/administrativelog-form.js